import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ServiceUsagesGroup_Create_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ServiceUsagesGroup_Create(
      $isOptional: Boolean
      $label: String!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      createMissionServiceUsagesGroup(
        isOptional: $isOptional
        label: $label
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useCreateMissionServiceUsagesGroupMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ServiceUsagesGroup_Create_Mutation,
  );
